webpackJsonp([165889800748998],{

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/7.31d4edf8.jpg";

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3.31651cf7.jpg";

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.f21621bf.jpg";

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageTitleQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(10);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Gallery = __webpack_require__(25);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _ = __webpack_require__(844);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(852);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(132);
	
	var _6 = _interopRequireDefault(_5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Lightbox from 'react-images'
	
	
	var DEFAULT_IMAGES = [{
	  id: '1',
	  src: '/china/timeline',
	  thumbnail: _2.default,
	  caption: 'China',
	  description: ''
	}, {
	  id: '2',
	  src: '/japan/timeline',
	  thumbnail: _4.default,
	  caption: 'Japan',
	  description: ''
	}, {
	  id: '3',
	  src: '/korea/timeline',
	  thumbnail: _6.default,
	  caption: 'Korea',
	  description: ''
	}];
	
	var TimelinesPage = function (_React$Component) {
	  _inherits(TimelinesPage, _React$Component);
	
	  function TimelinesPage() {
	    _classCallCheck(this, TimelinesPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  TimelinesPage.prototype.render = function render() {
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    var siteDescription = this.props.data.site.siteMetadata.description;
	    var siteTitleSub = 'Timelines';
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          siteTitleSub + ' | ' + siteTitle
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'main' },
	        _react2.default.createElement(
	          'section',
	          { id: 'one' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Timelines'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { id: 'two' },
	          _react2.default.createElement(_Gallery2.default, {
	            images: DEFAULT_IMAGES.map(function (_ref) {
	              var id = _ref.id,
	                  src = _ref.src,
	                  thumbnail = _ref.thumbnail,
	                  caption = _ref.caption,
	                  description = _ref.description;
	              return {
	                src: src,
	                thumbnail: thumbnail,
	                caption: caption,
	                description: description
	              };
	            })
	          })
	        )
	      )
	    );
	  };
	
	  return TimelinesPage;
	}(_react2.default.Component);
	
	exports.default = TimelinesPage;
	var pageTitleQuery = exports.pageTitleQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-timelines-js-32247772045e67c4777e.js